import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { LanguageState, TypesUtilsService } from '@osos/shared/legacy-core';
import { LocalizedValueModel } from '@osos/shared/types';

@Pipe({
  name: 'localeLanguageName',
  standalone: true,
})
export class LocaleLanguageNamePipe implements PipeTransform {
  constructor(
    private store: Store,
    private typeUtile: TypesUtilsService,
  ) {}

  transform(locales: string[]): string {
    const supportedLangs: Record<string, LocalizedValueModel> =
      this.store.selectSnapshot(LanguageState.supportedLocaleLabels);

    return locales
      .map((locale) => this.typeUtile.getLocaleString(supportedLangs[locale]))
      .join(', ');
  }
}
